import { render, staticRenderFns } from "./viewDestructedAsset.vue?vue&type=template&id=324950ec&scoped=true&"
import script from "./viewDestructedAsset.vue?vue&type=script&lang=js&"
export * from "./viewDestructedAsset.vue?vue&type=script&lang=js&"
import style0 from "./viewDestructedAsset.vue?vue&type=style&index=0&id=324950ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324950ec",
  null
  
)

export default component.exports